export const examplesStyles = [
  {
    id: 'watercolor',
    name: 'Watercolor',
    description: 'Soft, flowing watercolor art perfect for elegant home decor',
    original: '/examples/watercolor/original.jpg',
    generated: '/examples/watercolor/generated.jpg',
    link: '/ai-pet-portrait-generator',
  },
  {
    id: 'sketch',
    name: 'Pencil Sketch',
    description: 'Detailed pencil sketch with beautiful shading and texture',
    original: '/examples/sketch/original.jpg',
    generated: '/examples/sketch/generated.jpg',
    link: '/ai-pet-portrait-generator',
  },
  {
    id: 'oil',
    name: 'Oil Painting',
    description: 'Classic oil painting style with rich colors and depth',
    original: '/examples/oil/original.jpg',
    generated: '/examples/oil/generated.jpg',
    link: '/ai-pet-portrait-generator',
  },
  // Cartoon style removed from Examples (kept Crayon as requested)
  {
    id: 'ink',
    name: 'Chinese Ink Painting',
    description: 'Traditional East Asian brushwork and elegance',
    original: '/examples/ink/original.jpg',
    generated: '/examples/ink/generated.jpg',
    link: '/ai-pet-portrait-generator',
  },
  {
    id: 'crayon',
    name: 'Crayon',
    description: 'Playful and colorful hand-drawn charm',
    original: '/examples/crayon/original.jpg',
    generated: '/examples/crayon/generated.jpg',
    link: '/ai-pet-portrait-generator',
  },
  {
    id: 'popart',
    name: 'Urban Comic',
    description: "Rockstar's cover-art aesthetic with bold outlines",
    original: '/examples/popart/original.jpg',
    generated: '/examples/popart/generated.jpg',
    link: '/ai-pet-portrait-generator',
  },
];


